<template>
  <div
    :title="$t('menu_payment.title')"
    :readonly="editing"
    :systemDependency="'reserve'"
    v-if="available_pay_receivers && available_pay_receivers.length > 1"
  >
    <BaseSelect 
      class="w-100"
      fullWidth
      v-model="pay_receiver_id"
      @blur="onEditFinish"
      v-if="available_pay_receivers"
    >
      <option :value="null" disabled>
        {{ $t("menu_payment.choose_ph") }}
      </option>
      <option
        v-for="(receiver, index) in available_pay_receivers"
        :key="receiver._id"
        :value="receiver._id"
      >
        №{{ index + 1 }} - {{ capitalize(receiver.gateway) }} ({{
          receiver.company_name ||
          receiver.liqpay_public_key ||
          receiver.wayforpay_merchant
        }})
      </option>
    </BaseSelect>
    <!-- <p class="comment c-gray">
      {{ $t("menu_payment.desc") }}
    </p> -->

    <!-- <IQOSActions
      :editing="editing"
      @edit="showEditUI"
      @accept="onEditFinish"
      @cancel="hideEditUI"
    /> -->
  </div>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import IQOSActions from "@/components/IQOSActions.vue";

import BlackSelect from "@/components/BlackSelect.vue";

import PaymentAPI from "@/api/payment";

export default {
  components: {
    IQOS,
    IQOSActions,
    BlackSelect,
  },
  data() {
    return {
      editing: false,

      pay_receiver_id: null,

      available_pay_receivers: null,
    };
  },
  methods: {
    fetchInitialList() {
      PaymentAPI.getPayReceivers(this.$store.state.cafe._id)
        .then((data) => {
          this.available_pay_receivers = data.pay_receivers;
        })
        .catch((error) => {
          alert(error);
        });
    },
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.reset();
    },
    onEditFinish() {
      this.editing = false;

      this.$store.commit("setReservePayReceiver", this.pay_receiver_id);
      this.$store.dispatch("saveCafe");
    },
    reset() {
      this.pay_receiver_id = this.cafe.reserve.pay_receiver_id || null;
    },
    capitalize(val) {
      return val.substring(0, 1).toUpperCase() + val.substring(1);
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
  },
  mounted() {
    this.reset();
    this.fetchInitialList();
  },
};
</script>

<style>
</style>